module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }